import { TableProps } from 'antd'

export const CommonTableProps: Pick<TableProps<unknown>, 'scroll'> = {
  scroll: { x: 1500, y: '60vh' }
}
